import { EntityModel } from '@/interfaces'
import {
  ALL_AVAILABILITY_STATUS_QUERY,
  CREATE_AVAILABILITY_STATUS_MUTATION,
  DELETE_AVAILABILITY_STATUS_MUTATION,
  FORCE_DELETE_AVAILABILITY_STATUS_MUTATION,
  SINGLE_AVAILABILITY_STATUS_QUERY,
  UPDATE_AVAILABILITY_STATUS_MUTATION,
} from './graphql'
import availabilityStatusTenantSettingsEntity from '@/entities/availabilityStatusTenantSettings/entity'

const travelAvailabilityStatusModel: EntityModel = {
  name: 'availabilityStatus',
  namePlural: 'availabilityStatus',
  uniqueName: 'travelAvailabilityStatus',
  uniqueNamePlural: 'travelAvailabilityStatus',
  path: 'travel/availability_status',
  baseUrl: '/travel/availability-status',
  translationPrefix: 'entities:travelAvailabilityStatus.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_AVAILABILITY_STATUS_QUERY,
    getSingle: SINGLE_AVAILABILITY_STATUS_QUERY,
    create: CREATE_AVAILABILITY_STATUS_MUTATION,
    update: UPDATE_AVAILABILITY_STATUS_MUTATION,
    delete: DELETE_AVAILABILITY_STATUS_MUTATION,
    forceDelete: FORCE_DELETE_AVAILABILITY_STATUS_MUTATION,
  },
  attributes: {
    label: {
      name: 'label',
      label: 'entities:travelAvailabilityStatus.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    status: {
      name: 'status',
      label: 'entities:travelAvailabilityStatus.attributes.status.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'BOOKABLE',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:travelAvailabilityStatus.attributes.status.selectOptions.BOOKABLE.label',
          value: 'BOOKABLE',
        },
        {
          label: 'entities:travelAvailabilityStatus.attributes.status.selectOptions.REQUEST.label',
          value: 'REQUEST',
        },
        {
          label: 'entities:travelAvailabilityStatus.attributes.status.selectOptions.WAITLIST.label',
          value: 'WAITLIST',
        },
        {
          label: 'entities:travelAvailabilityStatus.attributes.status.selectOptions.WAITLIST_CONTINGENT_CHECK.label',
          value: 'WAITLIST_CONTINGENT_CHECK',
        },
        {
          label: 'entities:travelAvailabilityStatus.attributes.status.selectOptions.CLOSED.label',
          value: 'CLOSED',
        },
      ],
      validationType: 'string',
      validations: [],
    },
    isDefaultStatus: {
      name: 'isDefaultStatus',
      label: 'entities:travelAvailabilityStatus.attributes.isDefaultStatus.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    isDefaultWaitlistFallback: {
      name: 'isDefaultWaitlistFallback',
      label: 'entities:travelAvailabilityStatus.attributes.isDefaultWaitlistFallback.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    tenantSettings: {
      name: 'tenantSettings',
      label: 'entities:travelAvailabilityStatus.attributes.tenantSettings.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return availabilityStatusTenantSettingsEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelAvailabilityStatusModel
